(function() {
    'use strict';

    angular.module('app.core', [
        'ngRoute', 'ngAnimate', 'ngSanitize', 'ngTagsInput', 'ngQuill', 'ngCookies'
        // 'ngRoute', 'ngAnimate', 'ngSanitize', 'ngPrettyJson', 'ngTagsInput', 'ngQuill', 'ngCookies'
    ]);

})();